import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ContactInfoDto, ContactInfoTypeDto } from '@/api/generated';
import { themeColors } from '@/config/theme/themeColors.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { ContactDetailsContactInfoItem } from '@/views/contactsDetails/components/contactInfo/section/components/ContactDetailsContactInfoItem.comp.tsx';
import { CustomerDetailsAccordion } from '@/views/customerDetails/components/CustomerDetailsAccordion.comp.tsx';

type Props = {
  contactId: number;
  contactInfos: Array<ContactInfoDto>;
};

export const ContactDetailsContactInfo: React.FC<Props> = props => {
  const { contactId, contactInfos } = props;
  const { t } = useTranslationWithPrefix('views.contactsDetails.infos');

  return (
    <CustomerDetailsAccordion expanded>
      <Typography sx={{ color: themeColors.greyDark }} variant="f18Regular">
        {t('clickContactToCopy')}
      </Typography>
      <Grid container sx={{ px: 8 }}>
        <Grid size={5}>
          <Stack spacing={2}>
            <Box sx={{ textAlign: 'center' }}>
              <PhoneAndroidOutlinedIcon
                htmlColor={themeColors.accentColor}
                style={{ fontSize: '36px' }}
              />
            </Box>
            {contactInfos
              .filter(item => item.contactInfoType === ContactInfoTypeDto.Phone)
              .map(it => (
                <ContactDetailsContactInfoItem
                  contactId={contactId}
                  contactInfo={it}
                  key={it.contactInfoId}
                />
              ))}
          </Stack>
        </Grid>
        <Grid size={2} />
        <Grid size={5}>
          <Stack spacing={2}>
            <Box sx={{ textAlign: 'center' }}>
              <EmailOutlinedIcon htmlColor={themeColors.accentColor} style={{ fontSize: '36px' }} />
            </Box>
            {contactInfos
              .filter(item => item.contactInfoType === ContactInfoTypeDto.Email)
              .map(it => (
                <ContactDetailsContactInfoItem
                  contactId={contactId}
                  contactInfo={it}
                  key={it.contactInfoId}
                />
              ))}
          </Stack>
        </Grid>
      </Grid>
    </CustomerDetailsAccordion>
  );
};
